export const AppRoutes = {
    callback: '/callback',
    loggedOut: '/logged-out',
    home: '/home',
    feedback: '/product-feedback',
    designSystemOverview: '/design-system/general/overview',
    colorPalette: '/design-system/foundation/color-palette',
    dateTime: '/design-system/guidelines/date-time',
    designTokens: '/design-system/foundation/design-tokens',
    buttons: '/design-system/guidelines/buttons',
    dropdownOptions: '/design-system/guidelines/dropdown-options',
    utilityClasses: '/design-system/foundation/utility-classes',
    components: '/design-system/foundation/components',
    gettingStarted: '/design-system/resources/getting-started',
    personas: '/design-system/resources/personas',
    strataDesignPrinciples: 'design-system/resources/strata-design-principles',
    bemMethodology: '/design-system/resources/bem-methodology',
    emailSignature: '/brand-guidelines/email-signature',
    brandGuidelinesOverview: '/brand-guidelines/overview',
    definingOurBrand: '/brand-guidelines/defining-our-brand',
    brandStory: '/brand-guidelines/brand-story',
    brandGuidelinesDocument: '/brand-guidelines/brand-guidelines-document',
    nomenclature: '/brand-guidelines/nomenclature',
    logos: '/brand-guidelines/logos',
    typography: '/brand-guidelines/typography',
    templatesOverview: '/templates/overview',
    templates: '/templates/templates',
    files: '/templates/files',
    colors: 'brand-guidelines/colors',
    illustration: '/brand-guidelines/illustration',
    downloads: '/brand-guidelines/downloads',
    voiceTone: '/design-system/guidelines/voice-tone',
    writingBestPractices: '/design-system/guidelines/writing-best-practices',
    messagingGuidelines: '/design-system/guidelines/messaging-guidelines',
} as const;
